import { useCallback } from 'react';

import { Box, Typography, Button } from 'shared';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import { iconNames, Icon } from 'shared_DEPRECATED/components/Icon';

import { Dropdown } from 'shared/components/Dropdown';

type TCoachingToolCardMenuMoveToSprint = {
  sprints: { sprintId: string; title: string }[];
  onCoachingToolMove: (toSprintId: string) => void;
};

export const CoachingToolCardMenuMoveToSprint = ({
  sprints,
  onCoachingToolMove,
}: TCoachingToolCardMenuMoveToSprint) => {
  const handleMove = useCallback(
    (sprintId: string) => {
      onCoachingToolMove(sprintId);
    },
    [onCoachingToolMove]
  );

  return (
    <Dropdown
      anchorContent={
        <Flex width="100%" justifyContent="space-between">
          <Typography color="black">Move to</Typography>
          <Icon name={iconNames.arrowRight} />
        </Flex>
      }
      anchorSpacing={['zr md', 'md']}
      placement="right-start"
      withChevronIcon={false}
    >
      <Box style={{ width: '100%', overflow: 'auto' }} role="listbox">
        <Flex alignItems="stretch" flexDirection="column">
          {sprints.map(({ sprintId, title }) => (
            <Button
              key={sprintId}
              _focusVisible={{ outline: 'none' }}
              onClick={() => handleMove(sprintId)}
              width="100%"
              mb={1}
            >
              <Typography color="white">{title}</Typography>
            </Button>
          ))}
        </Flex>
      </Box>
    </Dropdown>
  );
};
